import mapiConfig from "../configs/mapi";
import { httpMStepsClient } from "./utils/httpService";

const MAPI_URL = mapiConfig.api.domain;

export interface StockRemarkItem {
  itemCode: string;
  whsCode: string;
  location?: string;
  itemName?: string;
  remarks: string;
}

export const bulkUpsertStockRemarks = async (
  items: StockRemarkItem[],
  updatedBy?: string,
) => {
  return await httpMStepsClient({
    baseURL: MAPI_URL,
    type: "POST",
    path: "/stock/remarks/bulk",
    body: { items, updatedBy },
  });
};

export const getAllStockRemarks = async () => {
  return await httpMStepsClient({
    baseURL: MAPI_URL,
    type: "GET",
    path: "/stock/remarks",
  });
};

export const getStockRemarkByItem = async (
  itemCode: string,
  whsCode: string,
) => {
  return await httpMStepsClient({
    baseURL: MAPI_URL,
    type: "GET",
    path: `/stock/remarks/${encodeURIComponent(itemCode)}/${encodeURIComponent(whsCode)}`,
  });
};

export const deleteStockRemark = async (itemCode: string, whsCode: string) => {
  return await httpMStepsClient({
    baseURL: MAPI_URL,
    type: "DELETE",
    path: `/stock/remarks/${encodeURIComponent(itemCode)}/${encodeURIComponent(whsCode)}`,
  });
};
